module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAUVBMVEUANYAAlUMLPHoPPngSQHcWRosWnlMiSW9VaFVXuYNYe6x9f0KNiTqPijiakjOjly6tvtat3cPSEDTWI0TgXXXp2+Tp49/twwnvrbnwrbr/zgDNqpk3AAAAdUlEQVR42m3OSRbAEBRE0RBpRaQn2f9Cw4Aa1K8Z79xDI6/b4nmkyXW+r9RKNsNgiNbcWudsy/Q433welxCWken1TOlC+/X7Vq+J7r2CZqqUwttM0/BzpjnXMUVmisy0TqSYSDGRYjJFFilyoRGUMihnvMr7AezhE00k67MGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/na.png
// module id = 350
// module chunks = 0